/**
 * Connector matrix + status timeline (Phase A.3).
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  GetConnectorMatrixResponse,
  GetConnectorTimelineQuery,
  GetConnectorTimelineResponse,
} from '../models';

export const fetchConnectorMatrix = (chargerId: string) =>
  ocppRequest<GetConnectorMatrixResponse>({
    method: 'GET',
    path: `connectors/${enc(chargerId)}`,
  });

export const fetchConnectorTimeline = (chargerId: string, q: GetConnectorTimelineQuery = {}) =>
  ocppRequest<GetConnectorTimelineResponse>({
    method: 'GET',
    path: `connectors/${enc(chargerId)}/timeline`,
    query: {
      evseId: q.evseId,
      connectorId: q.connectorId,
      since: q.since,
      until: q.until,
      limit: q.limit,
      offset: q.offset,
    },
  });
